//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import Modal from "../Reusable/Modal";
import TableActionButton from "../Reusable/TableActionButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import Button from "../Reusable/Button";
import { useState } from "react";
import TrashIcon from "../../Icons/TrashIcon";
import { useForm } from "react-hook-form";
import SwitchButton from "../Reusable/SwitchButton";

const PaymentMethodList = (props: any) => {
  const { setError } = useForm({});
  const {
    handleDelete,
    isLoading,
    handleActive,
    handleToogle,
    handleTendorToggle,
    handleQrToggle,
  } = props;
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [selectedpaymentMethod, setselectedPaymentMethod] = useState(null);
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Merchant Required",
      accessorKey: "is_merchant_required",
      cell: ({ row, getValue }) => {
        return (
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleToogle}
          />
        );
      },
    },
    {
      header: "Tender Required",
      accessorKey: "is_tender_required",
      cell: ({ row, getValue }) => {
        return (
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleTendorToggle}
          />
        );
      },
    },
    {
      header: "Qr Generation",
      accessorKey: "is_generate_qr",
      cell: ({ row, getValue }) => {
        return (
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleQrToggle}
          />
        );
      },
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => {
        return (
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleActive}
          />
        );
      },
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <div className={tw`grid grid-cols-2 items-center `}>
            <AccessControl
              children={<TableActionButton editPath={`/edit/${getValue()}`} />}
              allowedPermissions={["can_update_setting"]}
            />
            <button
              type="button"
              disabled={isLoading || false}
              onClick={() => {
                setselectedPaymentMethod(row?.original.id);
                setOpenDeletePopup(!openDeletePopup);
              }}
              className="focus:outline-none"
            >
              <TrashIcon color={"var(--primary)"} />
            </button>
          </div>
        </>
      ),
    },
  ];
  return (
    <>
      <DataTable
        url={APIS.PAYMENT_METHOD}
        queryKey={"payment-method"}
        columns={defaultColumns}
        addNewPagePath={"/create"}
        tableName={"payment-method"}
      />
      <Modal isOpen={openDeletePopup} setIsOpen={setOpenDeletePopup} title={""}>
        <div className={tw`flex flex-col justify-center items-center  h-fit`}>
          <p className={tw`text-lg font-semibold mb-4`}>
            Are you sure you want to delete ?
          </p>
          <div className={tw`mt-6 flex gap-x-6 items-center`}>
            <div className={tw`w-24`}>
              <Button
                label={"Yes"}
                isLoading={isLoading}
                onClick={() =>
                  handleDelete(
                    selectedpaymentMethod,
                    setOpenDeletePopup,
                    setError
                  )
                }
              />
            </div>
            <div>
              <button
                type="button"
                className={tw`w-full px-[24px] py-2 rounded  focus:outline-none bg-[#EEF5F4]`}
                onClick={() => setOpenDeletePopup(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PaymentMethodList;
